import React, { useEffect, useState } from 'react';
import ReactPaginate from 'react-paginate';
import './style.css';
import Dropdown from '../Dropdown';

export default function Pagination({ itemsPerPage, items, getItems }) {
  const [currentPage, setCurrentPage] = useState(0);
  const [actualItemsPerPage, setActualItemsPerPage] = useState(itemsPerPage);

  useEffect(() => {
    setCurrentPage(0);
  }, [items, actualItemsPerPage]);

  useEffect(() => {
    const offset = (currentPage * actualItemsPerPage) % items.length;
    let returnedItems = items.slice(offset, offset + actualItemsPerPage);
    getItems(returnedItems);
  }, [currentPage, items, actualItemsPerPage, getItems]);

  const getPageCount = () => {
    return Math.ceil(items.length / actualItemsPerPage);
  };

  return (
    <div className="wrapper">
      <div className="horizontal-align">
        <span className="description-text">Records per page:</span>
        <Dropdown
          width="70px"
          options={[
            { label: itemsPerPage, value: itemsPerPage },
            { label: 25, value: 25 },
            { label: 50, value: 50 },
            { label: 100, value: 100 },
          ]}
          value={actualItemsPerPage}
          onChange={(selected) => {
            setActualItemsPerPage(parseInt(selected.value));
          }}
        />
        <span className="description-text">&nbsp;out of {items.length}</span>
      </div>
      <ReactPaginate
        previousLabel="Previous"
        nextLabel="Next"
        breakLabel="...."
        breakClassName="page-item"
        breakLinkClassName="page-link"
        pageCount={getPageCount()}
        forcePage={currentPage}
        pageRangeDisplayed={2}
        marginPagesDisplayed={1}
        onPageChange={(event) => setCurrentPage(event.selected)}
        containerClassName="pagination"
        pageClassName="page-item"
        pageLinkClassName="page-link"
        previousClassName="page-item"
        previousLinkClassName="page-link"
        nextClassName="page-item"
        nextLinkClassName="page-link"
        activeClassName="active"
      />
    </div>
  );
}
